import React, { useState, useEffect, useRef } from "react";
import Items from '../items/Items';
import { tipoArticulos} from "../../data/catalogos"


const descriptionEditorOptions = { height: 100 };

const MarcoAro = props => {
        return (
        <Items title="Marcos-Aros" typeId={tipoArticulos.MarcoAro} ></Items>
    );
}

export default MarcoAro;